<template>
<b-row>
    <b-col>
        <div class="headlinehome">
            <div class="row">
                <div>
                    <b-container class="mx-auto">
                        <b-row>
                            <b-col v-for="(portfoliok, index) in portfolio" lg="4" md="6" sm="6" xs="12" ml-md-auto class="d-flex justify-content-center mb-3">
                                <div @click="clickedToViewinModal(index)">
                                    <div class="picportfoliohome">
                                        <div v-if="langfrench">
                                            <b-img :src="wurl + '/imgsrv/' + portfoliok.portfolio_pic_fr" alt="Responsive image"></b-img>
                                            <div class="overlayonhover"></div>
                                            <div class="textcaption">
                                                <h3>{{ portfoliok.portfolio_title_fr }}</h3>
                                            </div>
                                            <div class="textinside">
                                                {{ portfoliok.portfolio_smalldescription_fr }}
                                            </div>
                                        </div>
                                        <div v-else>
                                            <b-img :src="wurl + '/imgsrv/' + portfoliok.portfolio_pic_en" alt="Responsive image"></b-img>
                                            <div class="overlayonhover"></div>
                                            <div class="textcaption">
                                                <h3>{{ portfoliok.portfolio_title_en }}</h3>
                                            </div>
                                            <div class="textinside">
                                                {{ portfoliok.portfolio_smalldescription_en }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
            </div>
        </div>
    </b-col>
    <div>
        <b-modal ref="inportfolio" hide-footer size="portfolio" :title="this.title_in_modal">
            <div>
                <b-row class="mainPortfolioContent">
                    <div>
                        <div v-if="categorieRadio">
                            <aplayer autoplay :music="{
    title: 'Spot Radio',
    artist: ' ',
    src: link_for_audio_to_load_in_modal,
    pic: wurl + '/imgsrv/hp_design.png'
  }" />
                        </div>
                        <div v-else>
                            <b-img :src="wurl + '/imgsrv/' + this.pic_in_modal" fluid alt="Responsive image"></b-img>
                        </div>
                        <div class="maintPortfolioContentText">
                            <div v-html="text_in_modal"></div>
                        </div>
                    </div>
                </b-row>
            </div>
            <div v-if="langfrench">
                <b-button class="mt-3" block @click="$refs['inportfolio'].hide();closemodal()">Fermer</b-button>
            </div>
            <div v-else>
                <b-button class="mt-3" block @click="$refs['inportfolio'].hide();closemodal()">Close</b-button>
            </div>
        </b-modal>
    </div>
</b-row>
</template>

<script>
import axios from "axios";
//bus for handling component interconnection
import {
    EventBus
} from "@/event-bus.js";
import {
    globalSiteSetting
} from "../main.ts";
export default {
    props: {
        catToView: {
            type: String
        },
        catKey: {
            type: String
        }
    },
    data() {
        return {
            wurl: globalSiteSetting.siteurl,
            langfrench: true,
            categorieRadio: false,
            categorieToView: '',
    
            content_fr: "",
            title_fr: "fdfddf",
            portfolio_categorie_fr: "",

            pic_in_modal: '',
            title_in_modal: '',
            text_in_modal: '',
            audio_in_modal:'',
            link_for_audio_to_load_in_modal:'',

            content_en: "",
            title_en: "",
            portfolio_categorie_en: "",

            portfolio_pic: "",
            portfolio_pic_en: "",

            portfolio_pic_detail_fr: "",
            portfolio_pic_detail_en: "",

            headerpic: "ajaxloader.gif",
            portfolio: []

        }
    },
    methods: {
        retrieveData() {
            var app = this;
            var weburl = this.wurl;
            var cat = this.categorieToView
            var idcat = this.catKey
            //check for viewportfolio view or entire list
            if ((cat == 'website') || (cat == 'corpovideo') || (cat == 'graphicdesign') || (cat == 'tvprogram') || (cat == 'commercial') || (cat == 'logocreation') || (cat == 'radio')) {
                axios
                    .get(weburl + "/api.data.php?req=dynamicdata&p=portfolio&c=" + cat + "&auth=razafy", {
                        crossDomain: true,
                    })
                    .then((response) => {
                        //put result to available array
                        this.portfolio = this.portfolio.concat(response.data);
                    });
            }
        },
        clickedToViewinModal(i) {
            //console.log('yes launch modal in portfolio and langfrench is:' + this.langfrench + ' and cat:' + this.categorieToView)
            //this.$bvModal.show('inportfolio')
            //check if radio
            if (this.categorieToView == 'radio') {
                this.categorieRadio = true
            }
            //show modal
            this.$refs['inportfolio'].show()
            if (this.langfrench == true) {
                this.title_in_modal = this.portfolio[i].portfolio_title_fr
                this.pic_in_modal = this.portfolio[i].portfolio_pic_detail_fr
                this.text_in_modal = this.portfolio[i].portfolio_content_fr
                this.audio_in_modal = this.portfolio[i].portfolio_audio_fr
                
            } else {
                this.title_in_modal = this.portfolio[i].portfolio_title_en
                this.pic_in_modal = this.portfolio[i].portfolio_pic_detail_en
                this.text_in_modal = this.portfolio[i].portfolio_content_en
                this.audio_in_modal = this.portfolio[i].portfolio_audio_en
            }
            //create audio link
                this.link_for_audio_to_load_in_modal = this.wurl+'/imgsrv/'+this.audio_in_modal
        },
        closemodal() {

            this.categorieRadio = false
            //console.log('modal was closed and categorieRadio:' + this.categorieRadio)

        },
        togglefrenchlangage() {
            this.langfrench = true
            //console.log('lang is now french')
        },
        toggleenglishlangage() {
            this.langfrench = false
            //console.log('lang is now english')
        },
        checkifcookieexistornot() {

            if (this.$cookie.get('gd_cookie') === 'accepted' || this.$cookie.get('gd_cookie') === 'rejected') {

                // try to read lang conf
                if (this.$cookie.get('gd_cookie') === 'accepted') {
                    if (this.$cookie.get('gd_langinfrench') === 'true') {
                        this.langfrench = true
                        EventBus.$emit('togglelangtofrench')
                    } else {
                        this.langfrench = false
                        EventBus.$emit('togglelangtoenglish')
                    }
                }
            }
        }
    },
    mounted() {
        this.categorieToView = this.catToView
        this.retrieveData()
        this.checkifcookieexistornot()
        //listen to langage change
        EventBus.$on('togglelangtofrench', () => {
            this.togglefrenchlangage()
        })
        EventBus.$on('togglelangtoenglish', () => {
            this.toggleenglishlangage()
        })
    }
}
</script>
